
export const handleMouseOver = (e: React.MouseEvent<HTMLParagraphElement, MouseEvent>) => {
    const target = e.target as HTMLParagraphElement;
    if (target) {
        target.style.cursor = "pointer";
    }
};